class LaveaBundlePicker extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.lavea-bundle-picker__card'));
    this.submitButton = this.querySelector('[data-add-to-cart]');
    this.status = this.querySelector('.lavea-bundle-picker__status');
    this.subscriptionSections = Array.from(
      document.querySelectorAll('section.shopify_subscriptions_app_block[data-variant-id]')
    );
    this.userPickedSubscribe = false;

    this.subscriptionSections.forEach((section) => {
      section.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          if (radio.checked) this.userPickedSubscribe = radio.dataset.radioType === 'selling_plan_group';
        });
      });
    });

    const selected = this.cards.find((card) => card.classList.contains('is-selected'));
    this.selectedVariantId = selected ? selected.dataset.variantId : null;
    if (this.selectedVariantId) this.syncSubscriptionSection(this.selectedVariantId);

    this.cards.forEach((card) => {
      card.addEventListener('click', () => this.select(card));
    });
    this.submitButton.addEventListener('click', () => this.addToCart());
  }

  select(card) {
    this.cards.forEach((c) => {
      c.classList.toggle('is-selected', c === card);
      c.setAttribute('aria-checked', c === card ? 'true' : 'false');
    });
    this.selectedVariantId = card.dataset.variantId;
    this.syncSubscriptionSection(this.selectedVariantId);
  }

  syncSubscriptionSection(variantId) {
    this.subscriptionSections.forEach((section) => {
      section.classList.toggle('shopify_subscriptions_app_block--hidden', section.dataset.variantId !== variantId);
    });
  }

  getSellingPlanId() {
    // A bundle card alone means one-time purchase. Subscribe & Save only
    // applies once the customer has explicitly clicked that radio themselves —
    // we don't trust whichever radio the widget defaults to as "checked".
    if (!this.userPickedSubscribe) return null;
    const section = this.subscriptionSections.find((s) => s.dataset.variantId === this.selectedVariantId);
    if (!section) return null;
    const subscribeRadio = section.querySelector('input[data-radio-type="selling_plan_group"]');
    return subscribeRadio ? subscribeRadio.dataset.sellingPlanId || null : null;
  }

  async addToCart() {
    if (!this.selectedVariantId) return;
    this.status.hidden = true;
    this.submitButton.disabled = true;
    this.submitButton.textContent = 'Adding…';
    const sellingPlanId = this.getSellingPlanId();
    const item = { id: Number(this.selectedVariantId), quantity: 1 };
    if (sellingPlanId) item.selling_plan = Number(sellingPlanId);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });
      if (!response.ok) throw new Error('Add to cart failed');
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    } catch (error) {
      this.status.hidden = false;
      this.status.textContent = 'Something went wrong — please try again.';
      this.submitButton.disabled = false;
      this.submitButton.textContent = 'Add to Cart';
    }
  }
}
customElements.define('lavea-bundle-picker', LaveaBundlePicker);
